import React, { useMemo } from 'react';
import { Col, createArrayInRange, Row } from '@visalex/core';

import { useTranslation } from 'next-i18next';

import OptionColumns, { OptionColumnType } from '../OptionColumns/OptionColumns';

import commonStyles from '../SolutionsPage.module.scss';
import styles from './BestTechnology.module.scss';

const BestTechnology = () => {
  const { t, i18n } = useTranslation();
  const items: OptionColumnType[] = useMemo(
    () =>
      createArrayInRange(0, 4).map((index) => ({
        key: index,
        title: t(`solutions.best-technology.items.${index}.title`),
        description: t(`solutions.best-technology.items.${index}.description`),
        imageUrl: `/images/solutions/icons/${index}.svg`,
        imageAlt: t(`solutions.best-technology.items.${index}.title`),
      })),
    [i18n.language]
  );

  return (
    <div className={styles['best-technology']}>
      <Row className={styles['best-technology__header']}>
        <Col>
          <h2>{t('solutions.best-technology.title')}</h2>
          <h3>{t('solutions.best-technology.subtitle')}</h3>
          <p className={commonStyles['description-big']}>{t('solutions.best-technology.description')}</p>
        </Col>
      </Row>
      <Row>
        <OptionColumns options={items} withDottedLines={false} />
      </Row>
    </div>
  );
};

export default BestTechnology;
